import { QueryHookOptions, useQuery } from '@apollo/react-hooks';
import {
  DefaultCouponMapping,
  LIST_DEFAULT_COUPON_MAPPING,
  Paginated,
} from '@bowtie-web/common';
import { ApiError } from '../error';

type Variables = {
  typeCodes?: string[];
  couponCodes?: string[];
  ordering?: string;
  noPagination?: boolean;
  page?: number;
  pageSize?: number;
};

const useListDefaultCouponMapping = (
  variables?: Variables,
  options?: QueryHookOptions,
) => {
  const {
    typeCodes = [],
    couponCodes = [],
    ordering,
    noPagination,
    page,
    pageSize,
  } = variables || {};

  const list = useQuery<{
    defaultCouponMappings: Paginated<DefaultCouponMapping[]>;
  }>(LIST_DEFAULT_COUPON_MAPPING, {
    variables: {
      type_code: typeCodes.join(','),
      coupon_code: couponCodes.join(','),
      ordering,
      no_pagination: noPagination,
      page,
      page_size: pageSize,
    },
    ...options,
  });

  if (list.error) {
    throw new ApiError(list.error.message);
  }

  return [list.data?.defaultCouponMappings.results || [], list] as const;
};

export default useListDefaultCouponMapping;
